export const GET_CONTRACTS = 'GET_CONTRACTS';
export const GET_SELECTED_CONTRACT = 'GET_SELECTED_CONTRACT';
export const GET_SELECTED_CONTRACT_LOADING = 'GET_SELECTED_CONTRACT_LOADING';
export const GET_CONTRACTS_IS_LOADING = 'GET_CONTRACTS_IS_LOADING';
export const GET_TRANSFER_PROCESS_CONFIG = 'GET_TRANSFER_PROCESS_CONFIG';
